// extracted by mini-css-extract-plugin
export default {"lazyLoader":"hH-z"};